
import axiosHttp from '../hooks/intercepter';
const BASE_URL = process.env.REACT_APP_BASE_URL;

const signIn = async (credentials) => {
    return axiosHttp.post(`${BASE_URL}/login`, credentials);
};

const superAdminSignIn = async (credentials) => {
    return axiosHttp.post(`${BASE_URL}/login`, credentials);
};

const register = async (userData) => {
    return axiosHttp.post(`${BASE_URL}/register`, userData);
};

const verifyEmail = async (token) => {
    return axiosHttp.post(`${BASE_URL}/verify-email`, { token });
};

const resendEmailVerification = async (email) => {
    return await axiosHttp.post(`${BASE_URL}/resend-verification`, { email });
};

export { signIn, superAdminSignIn, register, verifyEmail, resendEmailVerification }